<template>
  <b-card>
    <loading
      :active.sync="isLoading"
      :can-cancel="true"
      :is-full-page="fullPage"
    ></loading>
    <!-- <div v-if="items.length >= 1"> -->
    <b-row>
      <b-col md="4">
        <b-form-group>
          <b-form-select
            v-model="filter2"
            :options="select.filterOptions"
            required
            class="input-new"
            @change="resetFilter"
          />
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-input-group v-if="filter2 === '1'">
          <b-form-input
            v-model="form.name"
            type="text"
            id="filterInput"
            placeholder="Type to Search"
            class="input-new"
            @click="resetIndex"
          ></b-form-input>
        </b-input-group>
        <b-input-group v-if="filter2 === '2'">
          <b-form-input
            v-model="form.outlet_name"
            type="text"
            id="filterInput"
            placeholder="Type to Search"
            class="input-new"
            @click="resetIndex"
          ></b-form-input>
        </b-input-group>
        <b-input-group v-if="filter2 === '3'">
          <b-form-input
            v-model="form.date"
            type="date"
            id="filterInput"
            placeholder="Type to Search"
            class="input-new"
            @click="resetIndex"
          ></b-form-input>
        </b-input-group>
      </b-col>
      <b-col md="4">
        <b-form-group>
          <b-button
            variant="primary"
            class="input-new"
            v-if="filter2 !== null"
            @click="onClickSearch"
            >SEARCH</b-button
          >
          &nbsp;&nbsp;&nbsp;
          <b-button
            variant="warning"
            class="input-new"
            v-if="filter2 !== null"
            @click="clearFilter"
            >CLEAR</b-button
          >
        </b-form-group>
      </b-col>
    </b-row>

    <!-- TABLE -->
    <b-table
      show-empty
      head-variant="dark"
      striped
      hover
      bordered
      :items="items"
      :fields="fields"
      id="my-table"
    >
      <template v-slot:cell(index)="data">
        {{ pagination.startIndex + data.index }}
      </template>
      <template v-slot:cell(action)="data">
        <b-link @click="onClickView(data.item.id)"
          ><i class="ti-file" style="font-size:20px;"></i
        ></b-link>
      </template>
      <template v-slot:cell(date)="data">
        {{ moment(data.value).format("DD/MM/YYYY") }}
      </template>
    </b-table>
    <b-pagination
      v-if="!isLoading"
      v-model="pagination.current"
      :total-rows="pagination.total"
      :per-page="pagination.perPage"
      @change="onChangePage"
    ></b-pagination>
    <!-- </div> -->
  </b-card>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
export default {
  data() {
    return {
      moment: moment,
      isLoading: false,
      fullPage: true,

      items: [],
      select: {
        filterOptions: [
          { text: "Please Select", value: null },
          { text: "Name", value: "1" },
          { text: "Category", value: "2" },
          { text: "Date", value: "3" }
        ]
      },
      indexsearch: 1,
      filter2: null,
      form: {
        date: null,
        name: null,
        outlet_name: null,
        year: "",
        month: "",
        state: "",
        upline: "",
        page: 1
      },
      pagination: {
        total: 0,
        current: 1,
        perPage: 10,
        startIndex: 0
      }
    };
  },
  components: {
    Loading
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    }
  },
  mounted() {},
  created() {
    if (this.filter) {
      this.filter2 = this.filter !== "null" ? this.filter : null;
      this.pagination.current = this.page !== "null" ? this.page : null;
      this.indexsearch = this.page !== "null" ? this.page : null;
      this.form.name = this.name !== "null" ? this.name : null;
      this.form.date = this.date !== "null" ? this.date : null;
      this.form.outlet_name =
        this.outlet_name !== "null" ? this.outlet_name : null;

      if (this.filter !== "null") {
        this.onClickSearch();
      } else {
        this.pagination.current = this.page !== "null" ? this.page : null;
        this.getStockout();
      }
    } else {
      this.getStockout();
    }
  },
  props: {
    fields: {
      type: Array,
      required: true
    },
    state: {
      type: Number,
      required: true
    },
    upline: {
      type: String,
      required: true
    },
    year: {
      type: String,
      required: true
    },
    month: {
      type: String
    },
    filter: {
      type: String,
      default: null
    },
    page: {
      type: String
    },
    date: {
      type: String
    },
    name: {
      type: String
    },
    outlet_name: {
      type: String
    }
  },
  watch: {
    year(newVal) {
      if (newVal && this.upline !== "0") {
        this.getStockout();
      }
    },
    month(newVal) {
      if (newVal && this.upline !== "0") {
        this.pagination.current = 1;
        this.getStockout();
      }
    }
  },
  methods: {
    onClickView(id) {
      this.$router.push({
        path: `/stockout/viewstockout?id=${id}&cat=1&state=${this.state}&upline=${this.upline}&year=${this.year}&month=${this.month}&page=${this.pagination.current}&filter=${this.filter2}&date=${this.form.date}&name=${this.form.name}&outlet_name=${this.form.outlet_name}`
      });
    },
    resetFilter() {
      this.form.date = null;
      this.form.name = null;
      this.form.outlet_name = null;
    },
    clearFilter() {
      this.filter2 = null;
      this.form.date = null;
      this.form.name = null;
      this.form.outlet_name = null;
      this.getStockout();
    },
    resetIndex() {
      this.indexsearch = 1;
    },
    onClickSearch() {
      this.isLoading = true;
      this.form.page = this.indexsearch;
      this.form.year = this.year;
      this.form.month = this.month;
      this.form.state = this.state;
      this.form.upline = this.upline;

      if (this.filter2 === null) {
        this.getStockout();
      } else {
        this.$store.dispatch("searchStockoutAdmin", this.form).then(res => {
          this.isLoading = false;
          this.items = [];
          res.data.data.data.forEach(element => {
            let outletCat;
            if (element.outlet !== null) {
              outletCat = element.outlet.name;
            }
            this.items.push({
              name:
                element.userdetails !== null ? element.userdetails.name : "",
              outlet_name: element.outlethistory.outlet_name,
              category: outletCat,
              date: element.date,
              role: element.userdetails.access_lvl,
              total: element.total_price_gt,
              id: element.stock_id,
              type: element.type
            });
          });
          this.pagination.total = res.data.data.total;
          this.pagination.current = res.data.data.current_page;
          this.pagination.perPage = res.data.data.per_page;
          this.pagination.startIndex = res.data.data.from;
          this.indexsearch = res.data.data.current_page;
        });
      }
    },
    getStockout() {
      this.isLoading = true;
      let data = {
        user_id: this.upline === "0" ? 1 : this.upline,
        year: this.year,
        month: this.month ? this.month : "",
        page: this.pagination.current
      };
      // this.items = [];
      this.$store.dispatch("getStockoutAdmin", data).then(res => {
        this.isLoading = false;
        if (res.data.response.code === 100) {
          this.items = [];
          res.data.data.data.forEach(element => {
            let outletCat;
            if (element.outlet !== null) {
              outletCat = element.outlet.name;
            }
            this.items.push({
              name:
                element.userdetails !== null ? element.userdetails.name : "",
              outlet_name: element.outlethistory.outlet_name,
              category: outletCat,
              date: element.date,
              role: element.userdetails.access_lvl,
              total: element.total_price_gt,
              id: element.stock_id,
              type: element.type
            });
          });
          this.pagination.total = res.data.data.total;
          this.pagination.current = res.data.data.current_page;
          this.pagination.perPage = res.data.data.per_page;
          this.pagination.startIndex = res.data.data.from;
        }
        this.$emit("getItems", this.items.length);
      });
    },
    onChangePage(index) {
      this.pagination.current = index;
      // this.getStockout()
      if (this.filter2 === null) {
        this.getStockout();
      } else {
        this.indexsearch =
          this.pagination.current !== this.indexsearch
            ? this.pagination.current
            : this.indexsearch++;
        this.onClickSearch();
      }
    }
  }
};
</script>
<style lang="css" scoped></style>
